export enum SolarAbsenkung70 {
    YES = 'YES',
    NO = 'NO'
}

export class SolarAbsenkung70Item {

    public key: string;
    public description: string;

    constructor(key: string, description: string) {
        this.key = key;
        this.description = description;
    }

    public static getAll(): SolarAbsenkung70Item[] {
        return [
            new SolarAbsenkung70Item(SolarAbsenkung70.YES, 'A01 = YES'),
            new SolarAbsenkung70Item(SolarAbsenkung70.NO, 'A02 = NO'),
        ];
    }

}

